export default __webpack_public_path__ + "static/wave-mobile-f3012cda35c2abb10d244255d25f882e.png";